<div class="col-xs-12">
  <section id="section-we-are-finzy" class="row">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">We are finzy</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">finzy is India's premier peer
        to peer lending portal. We
        digitally connect investors to hand-picked borrowers to provide risk optimised returns that are as
        high as 2.5 times of bank Fixed
        Deposit on an average.</p>
    </div>

    <div class="row">
      <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/we-are-finzy/hand-picked-borrowers.svg"
                 alt="Get access to hand picked borrowers"
                 class="img-responsive icon">
            <p class="heading">Hand Picked Borrowers</p>
            <p class="description">Our sourcing methods and proprietary credit algorithm
              takes into account as many as
              130 parameters to get you access to prime borrowers
            </p>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/we-are-finzy/diversified-investments.svg"
                 alt="Make smart and diversified investments"
                 class="img-responsive icon">
            <p class="heading">Diversified Investments</p>
            <p class="description">Your investments are split into multiple loans at the
              click of a button. This granular investment across loans helps you optimise risk and
              return</p>
          </div>

          <div class="clearfix visible-md"></div>

          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/we-are-finzy/regular-monthly-returns.svg"
                 alt="Get regular monthly returns"
                 class="img-responsive icon">
            <p class="heading">Regular Monthly Returns</p>
            <p class="description">Now you can start earning EMIs. Your investments in loans
              help you receive monthly returns, which are credited directly into your registered bank
              account</p>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/we-are-finzy/power-of-compounding.svg"
                 alt="Re-invest your money with the power of compounding using re-invest pro"
                 class="img-responsive icon">
            <p class="heading">Power of Compounding</p>
            <p class="description">Unlock the power of compounding.You can now choose to
              re-invest your monthly returns in new loans on finzy through our powerful Re-invest PRO
              feature</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="section-finzy-takes-care" class="row grey-section">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">Finzy takes care of your investments</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">finzy helps you invest in a new
        asset
        class by connecting you with the
        right borrowers. You earn monthly returns by investing in personal loans that are risk optimised</p>
    </div>

    <div class="row">
      <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/finzy-takes-care/trust.svg"
                 alt="You can trust finzy"
                 class="img-responsive icon">
            <p class="heading">Trusted Platform</p>
            <p class="description">Finzy is an NBFC - P2P registered with RBI. We have a time-tested
              team and robust
              business processes to ensure we provide transparency to both investors and borrowers</p>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/finzy-takes-care/secure-documentation.svg"
                 alt="We ensure secure documentation"
                 class="img-responsive icon">
            <p class="heading">Secure Documentation</p>
            <p class="description">Finzy meets borrowers in person for execution of loan agreements,
              stamp paper,
              post-dated cheques and demand promissory note ensuring documentation is complete and
              legally bound</p>
          </div>
          <div class="clearfix visible-md"></div>
          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/finzy-takes-care/automated-emi-collection.svg"
                 alt="We use automated emi collection"
                 class="img-responsive icon">
            <p class="heading">Automated EMI Collection</p>
            <p class="description">Finzy collects monthly EMI electronically from the borrowers
              themselves and
              transfers them to your registered bank account. All information of your investment is
              available on your
              finzy dashboard</p>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-3 subsection">
            <img src="../../assets/images/finzy-takes-care/follow-up-and-recovery.svg"
                 alt="We ensure detailed follow-up and recovery"
                 class="img-responsive icon">
            <p class="heading">Follow up & Recovery</p>
            <p class="description">Finzy has a detailed follow-up and recovery process. This comprises
              of our
              call-center, field visits by
              our internal collection team, tie-ups with bank recognised collection agencies and
              lawyers</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="section-get-started " class="row">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">How you can get started</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">finzy makes the entire
        investment process simple and user friendly.
        <br>You can create your portfolio in a couple of minutes.
    </div>

    <div class="row">
      <div class="col-xs-12">
        <object id="get-started-horizontal"
                data="../../assets/images/how-do-you-get-started/get-started-horizontal.svg"
                class="img-responsive center-block hidden-xs"></object>
        <object data="../../assets/images/how-do-you-get-started/get-started-vertical.svg"
                class="img-responsive center-block visible-xs"></object>
      </div>
    </div>
  </section>

  <section id="section-why-invest-with-finzy" class="row grey-section">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">Why invest with finzy</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">We take care of your trust
        by
        assigning deserving credit rating to each borrower and supporting in investment, documentation,
        monthly
        collections, account reconciliation and recovery</p>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-10 col-md-offset-1">
        <div id="invest-with-finzy-carousel" class="carousel slide carousel-fade" data-ride="carousel"
             data-interval="3000">

          <div class="carousel-inner">
            <div id="simple-and-easy" class="row carousel-item item active">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading">Simple and Easy</p>
                <p class="subheading">finzy supports you at every step:</p>
                <ul class="checklist">
                  <li>Simplified documentation</li>
                  <li>Automating monthly collections and accounts reconciliation</li>
                  <li>Handling recovery process and supporting legal recourse</li>
                  <li>Visual dashboards for tracking investments</li>
                </ul>

                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel First Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>

            <div id="diversification" class="row carousel-item item">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading">Diversification</p>

                <p class="diversification-paragraph">Your investment is split across multiple loans
                  to give you an optimal balance of risk and return. This can be done at a click of a button through our
                  “finzyPRO+” feature or you can choose to pick the loans you want to invest in.</p>
                <p class="diversification-paragraph">For example, instead of your investment of 1 Lakh going to a single
                  borrower, at finzy it is split into atleast 5 borrowers of 20,000 each.</p>
                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel Second Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>

            <div id="credit-algorithm" class="row carousel-item item">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading">Credit Algorithm</p>
                <p class="subheading" id="credit-algorithm-subheading">Our credit assessment of a
                  borrower is based on a proprietary scientific algorithm that takes into account as many as 130
                  parameters like:
                </p>

                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <ul class="checklist">
                      <li>Demographic Information</li>
                      <li>Income and Employment details</li>
                    </ul>
                  </div>

                  <div class="col-xs-12 col-md-6">
                    <ul class="checklist">
                      <li id="leverage-ratios">Leverage Ratios</li>
                      <li>Field verification and Database checks</li>
                    </ul>
                  </div>
                </div>

                <p>finzy ensures Investors, the choice of the right Borrower</p>
                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel Third Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>

            <div id="transparency" class="row carousel-item item">
              <div class="content col-xs-12 col-lg-8">
                <p class="heading">Transparency</p>
                <p class="subheading">Finzy stands for transparency & trust, hence there are:</p>
                <ul class="checklist">
                  <li>No registration fees</li>
                  <li>No processing fees</li>
                  <li>No hidden charges</li>
                  <li>We take a small fee only when you earn your returns</li>
                </ul>

                <button class="action-button invest-now-button" [routerLink]="['/lenderintro']"
                        (click)="analyticsTracker.trackButtonClick('Investor Home/Campaign','INVEST NOW','Investor Carousel Fourth Tab')">
                  INVEST NOW
                </button>
              </div>
            </div>
          </div>

          <ol class="carousel-indicators">
            <li data-target="#invest-with-finzy-carousel" data-slide-to="0" class="active"></li>
            <li data-target="#invest-with-finzy-carousel" data-slide-to="1"></li>
            <li data-target="#invest-with-finzy-carousel" data-slide-to="2"></li>
            <li data-target="#invest-with-finzy-carousel" data-slide-to="3"></li>
          </ol>

          <a class="left carousel-control visible-lg" href="#invest-with-finzy-carousel"
             data-slide="prev">
            <img src="../../assets/images/carousel-arrows/arrow-left.svg" class="carousalArrow">
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control visible-lg" href="#invest-with-finzy-carousel"
             data-slide="next">
            <img src="../../assets/images/carousel-arrows/arrow-right.svg" class="carousalArrow">
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section id="section-return-of-investments" class="row grey-section">
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">Explore your return on investments</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">Based on our credit algorithm,
        borrowers
        are rated from A+1 (low risk)
        to C6 (high risk). Higher the risk you are willing to take, higher are your expected returns</p>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1">
        <div class="row">
          <div class="col-xs-12 col-sm-2 col-sm-offset-1 subsection">
            <img src="../../../assets/images/rating/A+.png"
                 class="img-responsive center-block icon"
                 alt="Invest in A category loans rated 7.99% to 9.99%">
            <p class="description">7.99 % - 9.99 %</p>
          </div>
          <div class="col-xs-12 col-sm-2  subsection">
            <img src="../../../assets/images/rating/A.png"
                 class="img-responsive center-block icon"
                 alt="Invest in A category loans rated 10.99% to 15.99%">
            <p class="description">10.99 % - 15.99 %</p>
          </div>
          <div class="col-xs-12 col-sm-2 subsection">
            <img src="../../../assets/images/rating/B.png"
                 class="img-responsive center-block icon"
                 alt="Invest in B category loans rated 16.99% to 21.99%">
            <p class="description">16.99 % - 21.99 %</p>
          </div>
          <div class="col-xs-12 col-sm-2 subsection">
            <img src="../../../assets/images/rating/C.png"
                 class="img-responsive center-block icon"
                 alt="Invest in C category loans rated 22.99% to 27.99%">
            <p class="description">22.99 % - 27.99 %</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-core-team-section class="section grey-section"></app-core-team-section>

  <section id="section-client-testimonials" class="row grey-section" #clientTestimonials>
    <div class="row">
      <h2 class="heading col-xs-10 col-xs-offset-1">What our customers say</h2>
    </div>

    <div class="row">
      <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
        Here is what investors who have experienced finzy have to say</p>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-10 col-md-offset-1">
        <div id="testimonials-carousel" class="carousel slide" data-ride="carousel" data-interval="3000">

          <div class="testimonial-cards carousel-inner">

            <div class="row item active">
              <div class="col-xs-12">
                <div class="row testimonial-card">
                  <div class="col-xs-12">
                    <img class="img-responsive img-circle testimonial-card-image"
                         alt="Girish Vyasamudri, an investor with finzy"
                         src="https://res.cloudinary.com/finzy/image/upload/v1539242301/testimonials/girish.jpg">
                    <p class="name">Girish Vyasamudri</p>
                    <p class="location">VP & Head of Operations at a Software Company,
                      Bangalore</p>
                    <p class="review">As someone who considers himself a seasoned investor, I
                      have been very
                      pleasantly surprised by the latest innovation on Finzy, namely
                      Reinvest-Pro. The feature not
                      only significantly reduces the risks and increases the returns, it also
                      does so in a very
                      seamless manner. The investor doesn't have to keep track of multiple
                      things and can let the
                      system work its magic, but still can change things any time he/she
                      wishes. A great addition to
                      the already attractive nature of the Finzy platform that every investor
                      has to take benefit
                      from.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row item">
              <div class="col-xs-12">
                <div class="row testimonial-card">
                  <div class="col-xs-12">
                    <img class="img-responsive img-circle testimonial-card-image"
                         alt="Kuldeep Patnaik, an investor with finzy"
                         src="https://res.cloudinary.com/finzy/image/upload/v1539242315/testimonials/kuldeep-pattanaik.jpg">
                    <p class="name">Kuldeep Patnaik</p>
                    <p class="location">Manager - Toyota, Bangalore</p>
                    <p class="review"> In this busy work life there isn't real scope
                      to understand investment options , evaluate them , and invest. Moreover,
                      the complications of
                      ups and downs of market impacting my investment. Finzy is strongly
                      recommended for people like
                      me... I started investing 8 months back and I am thoroughly impressed
                      with a consistent returns
                      of ₹ 13k coming to my account as interest each month with a wonderful
                      feature Reinvest-Pro. Now
                      this is what I love the most - finzy takes care of my investment with my
                      focus clearly on
                      returns and without need to understand the financial complexities.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row item">
              <div class="col-xs-12">
                <div class="row testimonial-card">
                  <div class="col-xs-12">
                    <img class="img-responsive img-circle testimonial-card-image"
                         alt="Urmila Ramgharia, an investor with finzy"
                         src="https://res.cloudinary.com/finzy/image/upload/v1539759781/testimonials/urmila_gz55an.jpg">
                    <p class="name">Urmila Ramgarhia</p>
                    <p class="location">Home Maker, Kolkata</p>
                    <p class="review">All my life , there was a sense of having
                      money but traditionally kept in fixed deposit with money at bank and
                      returns very less, till I
                      was introduced to finzy. Now all my FD has been moved to finzy and I get
                      almost 2.5 times FD
                      interest coming to me every month, that's smart - it helps me take care
                      of my monthly expenses
                      without depending on anybody + my investment is getting reinvested.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ol class="carousel-indicators">
            <li data-target="#testimonials-carousel" data-slide-to="0" class="active"></li>
            <li data-target="#testimonials-carousel" data-slide-to="1"></li>
            <li data-target="#testimonials-carousel" data-slide-to="2"></li>
          </ol>
        </div>
      </div>
    </div>
  </section>

  <app-we-have-been-in-the-news id="section-news-articles" class="row" #newsArticles></app-we-have-been-in-the-news>

  <section class="row grey-section">
    <app-awards-and-accreditations id="section-awards-and-accreditations"
                                   #awardsAndAccreditations></app-awards-and-accreditations>
  </section>
</div>